import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { coinLabel } from "@/lib/constants";
import { RewardCard } from "@/components/RewardCard";

export default function RewardsPage() {
  const { user, refreshMe } = useAuth();
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    api.get("/rewards").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  useEffect(() => {
    load();
    refreshMe();
  }, [load, refreshMe]);

  return (
    <div>
      <section className="rounded-3xl bg-[#0b2e20] text-white p-8 sm:p-12 grain overflow-hidden rise">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#a3e6be]">Твой баланс</p>
        <div className="font-display text-5xl sm:text-6xl font-extrabold mt-3 flex items-center gap-3" data-testid="rewards-balance">
          <Coins className="h-10 w-10 text-amber-400" />{coinLabel(user)}<span className="text-xl font-semibold text-white/60">коинов</span>
        </div>
        <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400/15 border border-amber-400/40 text-amber-300 font-semibold text-sm" data-testid="rewards-exchange-note">
          <Sparkles className="h-4 w-4" />Обменивай коины — награда выдаётся сразу
        </div>
        <p className="mt-4 text-white/70 max-w-lg text-sm">Загружай полезные материалы: за каждый одобренный файл начисляется 50 коинов.</p>
      </section>
      <div className="flex items-center justify-between mt-12">
        <h2 className="font-display text-2xl font-bold text-[#0b2e20]">Награды</h2>
        <Link to="/my-rewards" className="inline-flex items-center gap-1 text-sm font-semibold text-[#2e7d56] hover:text-[#1f5f42]" data-testid="go-my-rewards-link">Мои награды<ArrowRight className="h-4 w-4" /></Link>
      </div>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="rewards-list">
        {items && items.length === 0 && <p className="text-sm text-[#6b8a7b] col-span-full py-10 text-center" data-testid="rewards-empty">Награды скоро появятся</p>}
        {(items || []).map((r) => <RewardCard key={r.id} r={r} onRedeemed={load} />)}
      </div>
    </div>
  );
}
